import { all } from 'redux-saga/effects'
import { sagas as uniscrowSagas } from './uniscrow'

function* runAllSagas() {
  yield all([
    uniscrowSagas(),
  ])
}

export default runAllSagas;